import { billingPath } from "@/utils/accountRoutes";

/**
 * Home v2 — task derivation.
 *
 * "Suas tarefas" is the account's open-loop list. Today only a subset of the
 * signals it will eventually carry are readable from the client: billing comes
 * from the auth context, onboarding from the implementation service. The rest
 * (stuck channels, failing flows, open support tickets) need the
 * `GET /api/internal/home/state` aggregate that this redesign specifies — so
 * they are absent rather than faked.
 */

export function deriveTasks({ scenario, billingPaymentLink, accountId }) {
  const tasks = [];

  if (scenario === "debito") {
    tasks.push({
      id: "billing-overdue",
      tone: "billing",
      tag: "FINANCEIRO",
      title: "Fatura vencida",
      subtitle: "Regularize para voltar a utilizar",
      cta: "Pagar agora",
      primary: true,
      dismissible: false,
      href: billingPaymentLink || billingPath(accountId),
    });
  }

  return tasks;
}
